/* eslint-disable */
import React from 'react';
import { CallToActionScreenData } from './InteractiveQuoteForm';
import useStyles from './CallToActionScreen.styles';
import { VideoGrid } from './VideoGrid';
import TextLogo from '../../public/cmsAssets/assets/img/logo/TextLogo';
import InteractiveQuoteFormFooter from './InteractiveQuoteFormFooter';
import { SunrunThemeOptions } from '../../styles/sunrunTheme.styles';
import { brandColors } from '../../styles/sunrunTheme.styles';
interface CallToActionScreenProps {
  data: CallToActionScreenData;
}

/**
 * @deprecated V2 component
 */
export default function CallToActionScreen({
  data: { heading, subheading, formContent, videos, fullScreenImage, footer },
}: CallToActionScreenProps) {
  if (footer)
    footer.fields.textColor = fullScreenImage
      ? SunrunThemeOptions.brandColors.white
      : SunrunThemeOptions.brandColors.primaryMain;
  const { classes } = useStyles();
  return (
    <div
      className={classes.page}
      style={{ backgroundImage: `url(${fullScreenImage})` }}
    >
      <div className={classes.container}>
        <div className={classes.contentContainer}>
          <div className={classes.logo}>
            <TextLogo color={brandColors.primaryMain} width='95' />
          </div>
          <div className={classes.formContainer}>
            <div>
              <h1 className={classes.heading}>{heading}</h1>
              <h2 className={classes.subheading}>{subheading}</h2>
            </div>
            <form>{formContent}</form>
          </div>
        </div>
        <div className={classes.rightHalfContainer}>
          {videos && <VideoGrid videos={videos} />}
        </div>
      </div>
      {footer && <InteractiveQuoteFormFooter content={footer} />}
    </div>
  );
}
